
import { mapGetters } from 'vuex';

export default {
  name: 'DesignHome',
  computed: {
    ...mapGetters('menu', ['mainMenuItems']),
    menuItems() {
      return this.mainMenuItems;
    }
  }
};
